



import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpHandler } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError, retry, timeout, map, delay } from 'rxjs/operators';
import { Constant } from  'src/app/helpers/constants/constant';
import { EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { NgxSpinnerService } from "ngx-spinner"; 


@Injectable({
  providedIn: 'root'
})
export class LocalserviceService {

  invokeParenComponentFunction = new EventEmitter();    
  subsVar: Subscription;  

  constructor( private http: HttpClient,private spinner: NgxSpinnerService) { }

  dataLayer = window['dataLayer'] = window['dataLayer'] || [];
  

  public emitEvent(
    eventCategory: string,
    eventAction: string,
    eventLabel: string = null) {
    this.dataLayer.push({
      'event': 'gtmevent', 
      'eventCategory': eventCategory,
      'eventAction': eventAction, 
      'eventLabel': eventLabel 
    }); 

  }

    show(){
        this.spinner.show();
    }

    hide(){
      this.spinner.hide();
    }

  submitEvent(Category,Action,Label){
    this.emitEvent(Category,Action,Label)
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    }
    else {
      console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
    }
    return throwError('Something bad happened; please try again later.');
  }

    //Post Api Code
    public PostApi(url: string, data: any, options: object): Observable<any> {
      const headerOption = {
        headers: new HttpHeaders({ ...options })
      }

     // headerOption.append('x-ob-bypass' , Constants.x_ob_bypass)
      console.log(Object.keys(options))
      return this.http.post( url, data, headerOption).pipe(map(res => res), catchError(this.handleError));
    }


    OnCkcickOfSuccessButton(val) {    
      this.invokeParenComponentFunction.emit(val);    
    }
    OnCkcickOfFailureButton(val) {    
      this.invokeParenComponentFunction.emit(val);    
    }



}
